import { Stack } from '@mui/material';
import React from 'react';
import { TruncatedText } from '../truncated-text/truncated-text';
import { Label } from './label';
import { Value } from './value';

interface Props {
  label: string;
  value?: React.ReactNode | string;
  testId?: string;
  spacing?: number;
  isVisible?: boolean;
}

export function ViewLabelValue({
  label,
  value,
  testId,
  spacing,
  isVisible = true,
}: Props) {
  if (!isVisible) return null;

  const renderedValue =
    typeof value === 'string' ? (
      <TruncatedText text={value} limit={150} />
    ) : (
      value ?? '-'
    );

  return (
    <Stack spacing={spacing}>
      <Label>{label}</Label>
      <Value testId={testId}>{renderedValue}</Value>
    </Stack>
  );
}
